import React from "react";

const severityColors = {
  mild: "bg-[#C9FFD3] text-[#166534] border border-[#A3E6AF]",
  moderate: "bg-[#FEF9C3] border border-[#E8E3AD] text-[#854D0E]",
  severe: "bg-red-100 text-red-800",
};

const DetectedCard = ({ title, severity, confidence, description }) => {
  return (
    <div className="bg-white rounded-[20px] p-4 mb-4 w-full">
      <h3 className="text-sm font-semibold text-gray-800 mb-2">{title}</h3>
      <div className="flex items-center gap-3 mb-2">
        <span
          className={`text-xs font-semibold px-3 py-1 rounded-full ${
            severityColors[severity.toLowerCase()] ||
            "bg-gray-100 text-gray-700"
          }`}
        >
          {severity.charAt(0).toUpperCase() + severity.slice(1).toLowerCase()}
        </span>
        <span className="text-xs font-normal text-primary bg-[#F3F3F3] border border-[#DCE4DE] px-3 py-1 rounded-full">
          {confidence}
        </span>
      </div>
      <p className="text-xs text-black/80 mt-3">{description}</p>
    </div>
  );
};

export default DetectedCard;
